<template>
  <v-form ref="form">
    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            현재 비밀번호
            <span class="asterisk">*</span>
          </v-list-item-title>
          <v-text-field
            solo
            required
            ref="refCurrentPassword"
            placeholder="현재 비밀번호를 입력해주세요"
            height="52"
            :append-icon="pwShow1 ? 'mdi-eye' : 'mdi-eye-off'" :type="pwShow1 ? 'text' : 'password'"
            @click:append="pwShow1 = !pwShow1" 
            v-model="userData.currentPassword"
          />
        </v-list-item-content>
      </v-list-item>

      <PasswordForm :userData="userData" />

      <v-btn color="primary" x-large depressed block rounded @click="clickSave">
        비밀번호 변경하기
      </v-btn>
    </v-list>
    <ConfirmDialog ref="refConfirmDialog" @clickOk="clickPopupConfirm" />
  </v-form>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import PasswordForm from "./comp/PasswordForm.vue";
import ConfirmDialog from "@/_bayer/commonComp/dialog/ConfirmDialog.vue";

export default {
  components: { PasswordForm, ConfirmDialog },
  props: {
    userData: {
      type: Object,
    },
  },
  data() {
    return {
      pwShow1: false,
    }
  },
  mounted() {
    setTimeout(() => {
      this.$refs.refCurrentPassword.focus();
    }, 300);
  },
  computed: {
    ...mapGetters(["isDev", "meInfo"]),
  },
  methods: {
    clickSave() {
      // 필수체크
      const $h = this.$helper;
      const DT = this.userData;
      const RF = this.$refs;

      let msg = `현재 비밀번호를 입력해주세요`;
      if (!$h.requiredCheck(DT.currentPassword, RF.refCurrentPassword, msg))
        return;

      if (!RF.form.validate()) return;

      // if (!confirm("회원로그인 비밀번호를 변경하시겠습니까?")) return;
      this.$refs.refConfirmDialog.open("회원로그인 비밀번호를 변경하시겠습니까?"); 

      
    },
    clickPopupConfirm() { 
      const $h = this.$helper;
      const DT = this.userData;
      DT.endpoint = "changePassword";
      DT.endpointUser = "user";
      this.saveDataQuery(DT).then((res) => {
        console.log("res", res);
        if (res === undefined) return;
        if (res.returnCode < 0) {
          this.$helper.showTostMessage(
            "",
            "현재 비밀번호를 확인해주세요.",
            "error"
          );
          RF.refCurrentPassword.focus();
          return;
        }
        this.$helper.showTostMessage(
          "",
          "비밀번호 변경이 완료 되었습니다.",
          "success"
        );

        this.signOut();
        this.$router.push("/login");
      });

    },
    ...mapActions(["getMeInfo", "saveDataQuery", "signOut"]),
  },
};
</script>
<style lang="scss">
div.v-list:not(.v-select-list) {
  background: transparent !important;
  .v-list-item {
    padding: 0;
    .v-list-item__content {
      padding: 0;
    }
    .v-list-item__title {
      font-size: 14px;
      font-weight: bold;
      padding: 0 15px 5px;
      color: $primary-color;
      .asterisk {
        color: $text-red;
      }
    }
    &.email {
      .inner-content {
        display: flex;
        span {
          padding: 15px 6px;
          font-weight: 700;
        }
      }
    }
    .v-input {
      .v-input__slot {
        .v-btn {
          font-weight: 700;
          background-color: $mid-green;
          color: #ffffff;
          font-size: 12px;
          height: 28px;
          margin-right: -10px;
        }
      }
    }
    .v-input {
      & ~ .input-guide {
        display: block;
        font-size: 12px;
        padding: 0 10px 20px;
        margin-top: -5px;
      }
      &.error--text {
        & ~ .input-guide {
          display: none;
        }
      }
    }
  }
}
</style>